import { App, Modal } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import { modalConfig } from "../../../../../theme"
import { MultiProcessorView } from "./MultiProcessorView"
import { SingleProcessorView } from "./SingleProcessorView"

export const AutomateCreditsModal = ({
  open,
  onCancel,
  onSubmit = onCancel,
  processors = [],
  requestFetching = false
}) => {
  const { t } = useTranslation()
  const { modal } = App.useApp()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const isSingleProcessor = processors.length <= 1

  // CHA1-2905: closing (X/backdrop/Escape) before submitting asks for confirmation - "Continue"
  // dismisses this and returns to AutomateCreditsModal, "Close" actually closes it.
  const handleClose = () => {
    modal.confirm({
      ...modalConfig("info"),
      centered: !isMobile,
      title: t("Leave without submitting?"),
      content: t(
        "You haven't completed the access setup for all payment processors. If you leave now, your Credit Automation request won't be submitted."
      ),
      cancelText: t("Close"),
      okText: t("Continue"),
      onCancel
    })
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      centered={!isMobile}
      width={isSingleProcessor ? 442 : 910}
      title={null}
      footer={null}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      styles={isSingleProcessor ? undefined : { content: { padding: 24 } }}
      closeIcon={<Icon type="cross_small" />}
      getContainer={() => document.getElementById("main-layout")}
    >
      {!processors.length ? null : isSingleProcessor ? (
        <SingleProcessorView
          processor={processors[0]}
          onSubmit={onSubmit}
          requestFetching={requestFetching}
        />
      ) : (
        <MultiProcessorView
          processors={processors}
          isMobile={isMobile}
          onCancel={handleClose}
          onSubmit={onSubmit}
          requestFetching={requestFetching}
        />
      )}
    </Modal>
  )
}

export default AutomateCreditsModal
